/**
 * Per-user filter overrides coalesce with company config (mirrors backend).
 * - User date unset/empty → company
 * - User category null/undefined → company; "" → force no lock; slug → lock
 */

export function coalesceDateOverride(
  userVal: string | null | undefined,
  companyVal: string | null | undefined,
): string | null {
  const u = typeof userVal === "string" ? userVal.trim() : "";
  if (u) return u;
  const c = typeof companyVal === "string" ? companyVal.trim() : "";
  return c || null;
}

export function coalesceSponsorCategoryOverride(
  userVal: string | null | undefined,
  companyVal: string | null | undefined,
): string | null {
  if (userVal !== undefined && userVal !== null) {
    const u = String(userVal).trim();
    return u || null;
  }
  const c = typeof companyVal === "string" ? companyVal.trim() : "";
  return c || null;
}
